import { render, staticRenderFns } from "./Loader2.vue?vue&type=template&id=5af66a69&scoped=true&"
import script from "./Loader2.vue?vue&type=script&lang=js&"
export * from "./Loader2.vue?vue&type=script&lang=js&"
import style0 from "./Loader2.vue?vue&type=style&index=0&id=5af66a69&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af66a69",
  null
  
)

export default component.exports